const setLocalShowBillButton = (val) => {
  localStorage.setItem("showBillButton", val);
};
export default setLocalShowBillButton;
